import YourDepositsCard from '@/components/Card/LaunchPadCard/YourDepositsCard';
import classNames from 'classnames';
import InvalidVaultCards from './InvalidVaultCards';
import VaultList from './VaultList';
import './index.less';
export default function VaultPage() {
  return (
    <div className="syn-launchpad syn-scrollbar">
      {/* <VaultBanner />
      <LegalDisclaimer /> */}
      <div className="syn-launchpad-content">
        <div className={classNames('syn-launchpad-content-left-wrapper', 'syn-scrollbar')}>
          <div className="syn-launchpad-content-left">
            <VaultList />
          </div>
        </div>

        <div className={classNames('syn-launchpad-content-right-wrapper', 'syn-scrollbar')}>
          <div className="syn-launchpad-content-right">
            <YourDepositsCard />
            <InvalidVaultCards />
          </div>
        </div>
      </div>
    </div>
  );
}
